import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()

export class AuthService {
    isLoginDialog: any = false;
    oldData: any = {};
    constructor(private router: Router) { }

    isLoggedIn(): any {
        var token = localStorage.getItem("usertoken");
        var user_id = localStorage.getItem("member");
        if (token) {
            if (user_id) {
                return true;
            }
        } else {
            return false;
        }
    }

    logout() {
        localStorage.clear();
        this.router.navigate(["/login"]);
    }

    noLoginData(data: any) {
        console.log('this.router.url ', this.router.url);
        localStorage.setItem("no_login_data", data);
        localStorage.setItem("no_login_url", this.router.url);
    }
    removenoLoginData() {
        localStorage.removeItem("no_login_data");
        localStorage.removeItem("no_login_url");
    }
    setOldData(data: any) {
        this.oldData = data;
    }
}
